export const CalculatorConstants = {
    B5: 0.158765159867696,
    B6: 0.976846747519294,
    B7: 0.992282249173098,
    B8: 0.579933847850055,
    B9: 0.583241455347299,
    B10: 0.265711135611907,
    B11: 0.920617420066152,
    B12: 0.278941565600882,
    B13: 0.0970231532524807,
    B14: 0.357221609702315,
    B15: 0.81367144432194,
    B16: 0.341786108048512,
    C5: 0.296582138919515,
    C6: 0,
    C7: 5.01323042998898,
    C8: 3.50055126791621,
    C9: 5.2502756339581,
    C10: 2.38919514884234,
    C11: 8.1973539140022,
    C12: 5.40683572216097,
    C13: 0.206174200661522,
    C14: 4.31863285556781,
    C15: 6.80485115766262,
    C16: 10.2061742006615,
    E7: 2.13340904079383,
    E8: 1.71438809261301,
    E9: 0.958875413450937,
    E10: 1.35677177508269,
    E11: 1.86885446527012,
    E12: 1.82533406835722,
    E14: 0.887909592061742,
    E15: 2.39713120176406,
    E16: 5.24025358324146,
    J5: 0,
    J6: 0,
    J7: 1.47921719955899,
    J8: 1.71438809261301,
    J9: 0.346141124586549,
    J10: 0.233737596471885,
    J11: 0,
    J12: 0.71587651598677,
    J13: 0,
    J14: 0.382690187431092,
    J15: 0,
    J16: 0.685777287761852,
    D27: 0,
    D28: 0,
    D29: 0.295062678689246,
    D30: 0.489748031496063,
    D31: 0.0659281814363713,
    D32: 0.097831102907245,
    D33: 0,
    D34: 0.132402120717781,
    D35: 0,
    D36: 0.0886137350012765,
    D37: 0,
    D38: 0.0671923949443664,
    E27: 0.708860759493671,
    E28: 1.11490683229814,
    E29: 0.628048780487805,
    E30: 0.317460317460317,
    E31: 0.421768707482993,
    E32: 0.327433628318584,
    E33: 0.402,
    E34: 0.46875,
    E35: 0.441176470588235,
    E36: 0.426829268292683,
    E37: 0.37027027027027,
    E38: 0.751633986928105,
    G27: 1.24137931034483,
    G28: 1.0752427184466,
    G29: 2.4390243902439,
    G30: 2.4811320754717,
    G31: 2.16803278688525,
    G32: 2.9390243902439,
    G33: 2.06683168316832,
    G34: 1.83333333333333,
    G35: 0,
    G36: 2.36496350364964,
    G37: 2.07887323943662,
    G38: 1.49038461538462,
}
